<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"
import { buttonVariants } from "@/components/ui/button"

const props = withDefaults(defineProps<{
  isActive?: boolean
  class?: HTMLAttributes["class"]
}>(), {
  isActive: false,
})
</script>

<template>
  <a
    data-slot="pagination-link"
    aria-current="page"
    :class="
      cn(
        buttonVariants({
          variant: isActive ? 'outline' : 'ghost',
          size: 'icon',
        }),
        isActive && 'pointer-events-none',
        !isActive && 'cursor-pointer',
        props.class,
      )
    "
  >
    <slot />
  </a>
</template>
